<h2 class="form-title">{{ wording.fareTypeLabel }}</h2>
<multiselect *ngIf="fareTypeFieldConfig"
             [fieldConfig]="fareTypeFieldConfig"
             [options]="fareTypeList">
</multiselect>